// 使用浏览器原生 fetch API，避免 webpack 5 polyfill 问题
export function addUserRecord(data) {
  // const url = `https://xcdan.com/prod-api/system/addUserRecord`
  const url = `http://localhost:8081/system/addUserRecord`

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(async (response) => {
    const result = await response.json()
    // 返回类似 axios 的响应结构
    return {
      status: response.status,
      data: result
    }
  }).catch(error => {
    console.error('请求失败:', error)
    throw error
  })
}

